<template>
    <AppLayout title="Crear Categoria" :contrast="true">
        <Breadcrumb
            name="Categorias"
            routeName="categorias"
            page="Crear categoria"
        />

        <form class="p-2">
            <div class="flex flex-col lg:flex-row lg:w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos de categoria
                    </div>
                    <template v-if="$page.props.user.tipo !== 'sucursal_admin'">
                        <div class="flex flex-col h-24">
                            <label for="sucursal" class="my-1 text-gray-700">
                                Sucursal<span class="text-red-400">*</span>
                            </label>
                            <Dropdown
                                v-model="form.sucursal_id"
                                placeholder="Seleccionar sucursal"
                                :options="sucursales"
                                optionValue="id"
                                optionLabel="nombre"
                                id="sucursal"
                                class="h-[42px] flex items-center"
                            />
                            <small
                                v-if="errors?.sucursal_id"
                                id="sucursal_id-help"
                                class="p-error"
                            >
                                {{ errors?.sucursal_id }}
                            </small>
                        </div>
                    </template>
                    <div class="flex flex-col h-24">
                        <label
                            for="descripcion"
                            class="text-sm my-1 text-gray-700"
                        >
                            Descripción<span class="text-red-400">*</span>
                        </label>
                        <input
                            id="descripcion"
                            v-model="form.observacion"
                            type="text"
                            class="t-input"
                            placeholder="Detalles de producto"
                        />
                        <small
                            v-if="errors?.observacion"
                            id="destino_nombre-help"
                            class="p-error"
                        >
                            {{ errors?.observacion }}
                        </small>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="peso" class="text-sm my-1 text-gray-700"
                            >Peso
                        </label>
                        <input
                            id="peso"
                            v-model="form.peso"
                            type="number"
                            class="t-input"
                            placeholder="kg"
                            min="0.1"
                            max="100"
                            step="0.1"
                        />
                        <small
                            v-if="errors?.peso"
                            id="peso-help"
                            class="p-error"
                        >
                            {{ errors?.peso }}
                        </small>
                    </div>
                    <div class="flex space-x-2">
                        <div class="flex flex-col w-1/3 h-24">
                            <label for="alto" class="text-sm my-1 text-gray-700"
                                >Alto
                            </label>
                            <input
                                id="alto"
                                v-model="form.alto"
                                type="number"
                                class="t-input"
                                placeholder="cm"
                                min="1"
                                max="1000"
                            />
                        </div>
                        <div class="flex flex-col w-1/3">
                            <label
                                for="largo"
                                class="text-sm my-1 text-gray-700"
                            >
                                Largo
                            </label>
                            <input
                                id="largo"
                                v-model="form.largo"
                                type="number"
                                class="t-input"
                                placeholder="cm"
                                min="1"
                                max="1000"
                            />
                        </div>
                        <div class="flex flex-col w-1/3">
                            <label
                                for="ancho"
                                class="text-sm my-1 text-gray-700"
                                >Ancho</label
                            >
                            <input
                                id="ancho"
                                v-model="form.ancho"
                                type="number"
                                class="t-input"
                                placeholder="cm"
                                min="1"
                                max="1000"
                            />
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <small
                            v-if="errors?.alto"
                            id="alto-help"
                            class="p-error"
                        >
                            {{ errors?.alto }}
                        </small>
                        <small
                            v-if="errors?.largo"
                            id="largo-help"
                            class="p-error"
                        >
                            {{ errors?.largo }}
                        </small>
                        <small
                            v-if="errors?.ancho"
                            id="ancho-help"
                            class="p-error"
                        >
                            {{ errors?.ancho }}
                        </small>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="precio" class="text-sm my-1 text-gray-700"
                            >Precio
                        </label>
                        <input
                            id="precio"
                            v-model="form.precio"
                            type="number"
                            class="t-input"
                            placeholder="$0.00"
                        />
                        <small
                            v-if="errors?.precio"
                            id="precio-help"
                            class="p-error"
                        >
                            {{ errors?.precio }}
                        </small>
                    </div>
                    <div class="flex flex-col mb-4">
                        <div class="text-[12px] text-gray-600">
                            <span class="text-red-400">*</span>
                            <span>es requerido</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="store"> Crear categoria </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: {
        errors: Object,
        sucursales: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                nombre: null,
                observacion: null,
                sucursal_id: null,
                alto: null,
                largo: null,
                ancho: null,
                peso: null,
                precio: null,
            }),
        };
    },
    methods: {
        store() {
            this.form.nombre = this.form.observacion;
            this.form.post("/categorias");
        },
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>
